import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import StopPayoutComponent from "./component";
import { toast } from "react-toastify";

const StopPayoutContainer = ({ getDataFromAPI }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [partners, setPartners] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize] = useState(20);
  const [hasMore, setHasMore] = useState(true);
  const [openSelect, setOpenSelect] = useState(false);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);

  const [formData, setFormData] = useState({
    franchiseeId: "",
    block: true
  });
  const [openDialog, setOpenDialog] = useState(false);

  // ✅ Fetch partners function
  const fetchPartners = useCallback(async (page = 0, isLoadMore = false) => {
    if ((isLoadMore && loadMoreLoading) || (!isLoadMore && loading) || !hasMore) return;
    
    if (isLoadMore) {
      setLoadMoreLoading(true);
    } else {
      setLoading(true);
    }
    
    try {
      const response = await new Promise((resolve, reject) => {
        getDataFromAPI(
          `/dashboard/api/v2/admin/franchisee?pageNumber=${page}&pageSize=${pageSize}`,
          "GET",
          undefined,
          resolve,
          reject
        );
      });

      if (page === 0) {
        setPartners(response);
      } else {
        setPartners(prev => [...prev, ...response]);
      }

      setHasMore(response.length === pageSize);
      setPageNumber(page);
    } catch (err) {
      console.error("Partner API Error:", err);
      toast.error("Failed to load partners");
    } finally {
      if (isLoadMore) {
        setLoadMoreLoading(false);
      } else {
        setLoading(false);
      }
    }
  }, [loading, loadMoreLoading, hasMore, getDataFromAPI, pageSize]);

  const handleOpenSelect = (status) => {
    setOpenSelect(status);
    
    // When dropdown opens, fetch partners
    if (status) {
      fetchPartners(0, false);
    }
  };

  // ✅ Load more button click handler
  const handleLoadMore = () => {
    if (!loadMoreLoading && hasMore) {
      fetchPartners(pageNumber + 1, true);
    }
  };

  // ✅ Scroll load more (optional - keeping for compatibility)
  const handleScroll = (event) => {
    const listboxNode = event.currentTarget;
    if (
      listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 5 &&
      !loadMoreLoading &&
      hasMore
    ) {
      handleLoadMore();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        franchiseeId: parseInt(formData.franchiseeId),
        block: true
      };

      await new Promise((resolve, reject) => {
        getDataFromAPI(
          "/partner/api/v3/acc/block-payout",
          "POST",
          payload,
          (response) => {
            setOpenDialog(true);
            resolve(response);
          },
          (error) => {
            toast.error(error.message || "Failed to block payout");
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    navigate(-1);
  };

  return (
    <StopPayoutComponent
      formData={formData}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      loading={loading}
      partners={partners}
      openDialog={openDialog}
      handleCloseDialog={handleCloseDialog}
      navigate={navigate}
      handleOpenSelect={handleOpenSelect}
      openSelect={openSelect}
      handleScroll={handleScroll}
      hasMore={hasMore}
      handleLoadMore={handleLoadMore}
      loadMoreLoading={loadMoreLoading}
    />
  );
};

export default connect(null, { getDataFromAPI })(StopPayoutContainer);